import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUniDirectionalArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.33398 8H12.6673M12.6673 8L8.66732 4M12.6673 8L8.66732 12",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgUniDirectionalArrowRight;
